<script setup lang="ts">
import { streamerBrand } from './branding'
import { useHead } from '@unhead/vue'
import { RouterView, useRoute } from 'vue-router'
import { useUserInfoQuery } from '@client-streamer/queries/user-info/userInfo.query'
import { useAuthStore } from '@repo/ui'
import { useRouter } from 'vue-router'
import { watch } from 'vue'
import ToastProvider from '@client-streamer/components/toast/ToastProvider.vue'
import { DialogProvider, ErrorBoundary } from '@repo/ui'

const route = useRoute()
const router = useRouter()
const authStore = useAuthStore()
const userInfoQuery = useUserInfoQuery()

useHead({
  title: () => (route.meta.title ? `${route.meta.title as string} · ${streamerBrand.name}` : streamerBrand.fullName),
  meta: [...(route.meta.description ? [{ name: 'description', content: route.meta.description as string }] : [])],
  // Studio pages can be installed as the S3T web app; the phone remote links its own manifest.
  link: () => (route.meta.auth === true && !route.path.startsWith('/voice/') ? [{ rel: 'manifest', href: '/studio.webmanifest' }] : []),
})

watch(
  () => userInfoQuery.error.value,
  (error) => {
    if (error && typeof error === 'object' && 'statusCode' in error && (error as { statusCode: unknown }).statusCode === 401) {
      authStore.clearAuthState()
      if (route.matched.some((record) => record.meta.auth === true)) router.replace({ name: 'login' })
    }
  },
  {
    immediate: true,
  },
)
</script>

<template>
  <ToastProvider>
    <DialogProvider>
      <ErrorBoundary>
        <RouterView />
      </ErrorBoundary>
    </DialogProvider>
  </ToastProvider>
</template>
